export class FloatingLicenseSnapshot {
    UserId: number;
    Username: string;
    DateOfCount: Date;

    constructor(model?: FloatingLicenseSnapshot) {
        if (model) {
            this.UserId = model.UserId;
            this.Username = model.Username;
            this.DateOfCount = model.DateOfCount
                ? new Date(model.DateOfCount)
                : null;
        } else {
            this.UserId = null;
            this.Username = null;
            this.DateOfCount = null;
        }
    }
}
